import Grid, { GridProps } from "@material-ui/core/Grid";
import React from "react";
import { ElapsedCartTime } from "./ElapsedCartTime";

type ElapsedCartTimeGridProps = {
    visible?: boolean;
    eventId?: string;
} & GridProps;

export const ElapsedCartTimeGrid = (props: ElapsedCartTimeGridProps) => {
    const { visible, eventId, ...rest } = props;

    if (!visible) return null;

    return (
        <Grid {...rest}>
            <ElapsedCartTime eventId={eventId} />
        </Grid>
    );
};
